import AudioFileOutlinedIcon from "@mui/icons-material/AudioFileOutlined";
import CloseIcon from "@mui/icons-material/Close";
import ReplayOutlinedIcon from "@mui/icons-material/ReplayOutlined";
import {
    IconButton,
    LinearProgress,
    MenuItem,
    Stack,
    Tooltip,
    Typography,
} from "@mui/material";
import { useTheme } from '@mui/material/styles';
import { UppyFile } from "@uppy/core";
import { useAtom, useAtomValue } from "jotai";
import { FC } from "react";
import { UPLOAD_STATUS_MENU_ITEM_TEXTS } from "../../constants";
import { baseAtom, removeInterviewByID } from "../../stores/jotai/base";
import { discoverySessionAtom } from "../../stores/jotai/discovery-session";
import { fileUploadAtom } from "../../stores/jotai/fileUpload";
import { cancelRecordingUpload } from "../../util/cancelRecordingUpload";
import { interviewsAtom } from "../../stores/jotai/interviews/interviews";

interface IUploadStatusMenuItemProps {
    file: UppyFile;
}

const UploadStatusMenuItem: FC<IUploadStatusMenuItemProps> = (props) => {
    const { file } = props;
    const [base, setBase] = useAtom(baseAtom);
    const discoverySession = useAtomValue(discoverySessionAtom);
    const fileUploadAtomState = useAtomValue(fileUploadAtom);
    const [allInterview,]=useAtom(interviewsAtom);

    const { team } = base;
    const fileName = file?.meta?.name;
    const interviewID = file?.meta?.interviewID as string;
	const s3FileURL = file?.meta?.s3FileURL;
    const teamID = team?.groupID;
    const fileID = file?.id;
    const progress = file?.progress?.percentage;
    const progressBar = progress || 0;
    const uppy = fileUploadAtomState.uppyInstance;
    const theme = useTheme();
    const cancelUpload = () => {
        cancelRecordingUpload({
            uppy,
            file,
            discoverySession,
            teamID,
            onSuccess: () => {
                const isInterviewExist = allInterview?.length>0 ? allInterview : [];
                removeInterviewByID(setBase, interviewID, isInterviewExist);
            },
        });
    }

    return (
        <MenuItem
            key={fileID}
            sx={{
                display: "flex",
                ":hover": {
                    backgroundColor: theme?.custom?.hoverOptionColor,
                },
            }}
        >
            <Stack
                spacing={1}
                sx={{ marginRight: "10px" }}
            >
                <Stack
                    direction="row"
                    spacing={2}
                >
                    <AudioFileOutlinedIcon sx={{ paddingRight: "5px" }} />
                    <Typography
                        sx={{
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                        }}
                    >
                        {fileName}
                    </Typography>
                </Stack>
                <LinearProgress
                    variant="determinate"
                    className="iw-progress"
                    value={progressBar}
                />
            </Stack>
            <Stack
                direction="row"
                spacing={0}
                sx={{ marginLeft: "auto" }}
            >
                <Tooltip title={UPLOAD_STATUS_MENU_ITEM_TEXTS.RETRY_BUTTON.TOOLTIP}>
                    <IconButton onClick={() => uppy?.retryUpload(fileID)}>
                        <ReplayOutlinedIcon />
                    </IconButton>
                </Tooltip>
                <Tooltip title={UPLOAD_STATUS_MENU_ITEM_TEXTS.CANCEL_BUTTON.TOOLTIP}>
                    <IconButton
                        onClick={cancelUpload}
                        disabled={!interviewID && !s3FileURL}
                    >
                        <CloseIcon />
                    </IconButton>
                </Tooltip>
            </Stack>
        </MenuItem>
    );
};

export default UploadStatusMenuItem;
